var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 25.3332H19.0141M18.9998 20.5832V12.6665M23.9918 6.78292C22.1331 6.09312 21.3079 3.33233 19.1895 3.17358C19.0636 3.16414 18.937 3.16414 18.8111 3.17358C16.6928 3.33234 15.8675 6.09296 14.0089 6.78292C12.0408 7.51313 9.34975 6.01631 7.68331 7.68279C6.07931 9.28675 7.49871 12.0806 6.78344 14.0083C6.05222 15.978 2.99446 16.7928 3.1741 19.189C3.33285 21.3074 6.09364 22.1326 6.78344 23.9913C7.49874 25.919 6.07923 28.713 7.68331 30.3169C9.34952 31.9833 12.0407 30.4871 14.0089 31.2167C15.8671 31.9075 16.6931 34.6676 18.8111 34.826C18.937 34.8355 19.0636 34.8355 19.1895 34.826C21.3075 34.6676 22.1337 31.9073 23.9918 31.2167C25.9196 30.502 28.7137 31.9209 30.3173 30.3169C32.0389 28.5956 30.3802 25.8052 31.2897 23.8163C32.1303 21.9852 35.0015 21.1277 34.8265 18.8106C34.668 16.6926 31.908 15.8664 31.2172 14.0083C30.4876 12.0402 31.9838 9.34899 30.3173 7.68279C28.651 6.01623 25.9599 7.51318 23.9918 6.78292Z",
    stroke: "url(#paint0_linear_696_1974)",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_1974",
    x1: 9.99982,
    y1: 5,
    x2: 29.4998,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE456"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43FF99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingExclamation);
export default __webpack_public_path__ + "static/media/SettingExclamation.166cce58d00d469d16ff75d2d059ab7c.svg";
export { ForwardRef as ReactComponent };